<template>
  <system-page :page-settings="page">
    <div class="c-content u-text-center complete">
      <div class="complete-text">
        <p class="u-mb">
          新しいメールアドレスへ確認用のメールを送信しました。
        </p>
        <p>メールに記載されているURLを24時間以内にクリックして、メールアドレスの変更を完了してください。</p>
        <p>
          しばらくたってもメールが届かない場合は、以下のご確認をお願いいたします。<br>
          ・⼊⼒内容に間違いはないか<br>
          ・ご利⽤のキャリアの設定によって、メールが「迷惑メール」に分類されていないか<br>
          ・「info@mail.players.pokemon-card.com」からのメールが受信できる設定になっているか<br>
          ・ご⼊⼒いただいたメールアドレスで、すでに「ポケモンカードゲーム プレイヤーズクラブ」に登録を⾏なっていないか
        </p>
        <p>
          上記をご確認いただいた上でメールが届かない場合は、「<a href="https://www.pokemon-card.com/contact/" target="_blank">ポケモンカードゲーム サポートデスク</a>」にお問い合わせ下さい。
        </p>
      </div>
      <div class="to-mypage">
      <router-link to="/mypage" class="c-btn c-btn-primary-outline">マイページ</router-link>
      </div>
    </div>
  </system-page>
</template>

<script>
import SystemPage from '@/component/SystemPage.vue'
export default {
  name: 'MailChangeComplatePage',
  components: {
    SystemPage,
  },
  data: function() {
    return {
      page: {
        title: 'メール送信完了',
        desc: 'ポケモンカードゲーム プレイヤーズクラブ メール送信完了のページ。',
        breadcrumb: [
          { name: 'マイページ', path: '/mypage' },
          { name: 'ユーザー情報', path: '/mypage/profile' },
          { name: 'メールアドレス変更', path: '/mypage/user/mail' },
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '~@/assets/style/global' as g;
@use './style.scss';

.complete {
  .c-btn {
    margin-top: 55px;
  }

  @include g.sp {
    &-text {
      text-align: left;
    }
    .c-btn {
      margin-top: 50px;
    }
  }
}
.to-mypage {
  line-height: 1;
}
</style>
